var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "draggable-menu" },
    [
      _c("i", { staticClass: "triangle" }),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "draggable-content",
          attrs: { options: { draggable: ".draggable-item" } },
          model: {
            value: _vm.dragItems,
            callback: function ($$v) {
              _vm.dragItems = $$v
            },
            expression: "dragItems",
          },
        },
        _vm._l(_vm.dragItems, function (item, index) {
          return _c(
            "div",
            { key: "dragIndex" + index, staticClass: "draggable-item" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedColumns,
                    expression: "selectedColumns",
                  },
                ],
                attrs: { type: "checkbox", disabled: !item.selectable },
                domProps: {
                  value: item,
                  checked: Array.isArray(_vm.selectedColumns)
                    ? _vm._i(_vm.selectedColumns, item) > -1
                    : _vm.selectedColumns,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.selectedColumns,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = item,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.selectedColumns = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectedColumns = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectedColumns = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t(item.title))),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "btns" }, [
        _c(
          "div",
          { staticClass: "clearSelect", on: { click: _vm.clearSelect } },
          [_vm._v(_vm._s(_vm.$t("action.reset").toUpperCase()))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "confirm", on: { click: _vm.confirm } }, [
          _vm._v(_vm._s(_vm.$t("action.confirm").toUpperCase())),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }